// Splide init
function mmInitSplide() {
	var id = ".mm-cart-cross-sell-splide";
    var splideElem = document.querySelector(id);

	if (splideElem ) {
		var bar = splideElem.querySelector(".my-carousel-progress-bar");
		var crossSellSplide = new Splide(splideElem, {
			type: 'slide',
			arrows: false,
			pagination: false,
			gap: 0,
			perMove: 1,
			fixedWidth: 290,
			omitEnd: true,
		})

		crossSellSplide.on("mounted move", function () {
			var end = crossSellSplide.Components.Controller.getEnd() + 1;
			var rate = Math.min((crossSellSplide.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + "%";
		});
		crossSellSplide.mount();
	}
};

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
		ecoPartSum();
		sendDeliveryInstructions();
        //mmOpenCart();
    },
    { once: true }
);

/**
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/**
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
    return document.querySelector('.mm-cart-container');
}

/**
 * Get the cart item element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

/**
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);
    return itemEl.querySelector('[data-item-quantity]');
}

/**
 * Get the quantity of a specific cart item.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    if (!quantityEl) return 0;
    return Number.parseInt(quantityEl.dataset.itemQuantity) || 0;
}

/**
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} productVariantId - The product variant ID.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display quantity in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);
        if (quantityEl) {
            quantityEl.dataset.itemQuantity = newQuantity;
            quantityEl.innerText = newQuantity;
        }
    }
}

/**
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections[mmCartSectionId()];
    return el;
}

/**
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector('.mm-dc-products-container');
}

/**
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 **/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/**
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/**
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = document.querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/**
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            updateCartCount();
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/**
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/**
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = document.querySelector('.mm-cart-container');
    if (!innerCart) {
        console.error('mm-cart-container element not found');
        return data;
    }
	const crossSellMobile = innerCart.querySelector('.mm-cart-cross-sell');
	if (crossSellMobile && crossSellMobile.classList.contains('mm-show')){
		const newCrossSell = newCartEl.querySelector('.mm-cart-cross-sell');
		if (newCrossSell) {
			newCrossSell.classList.add('mm-show');
		}
	}
    const newCartContainer = newCartEl.querySelector('.mm-cart-container');
    if (newCartContainer) {
        innerCart.innerHTML = newCartContainer.innerHTML;
    }
	changeCrossSellCtaText();
    mmInitSplide();
	ecoPartSum();
	updateCartCount();
	adjustCartHeight();
    return data;
}

function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart-wrapper').id;
}

function mmCartSectionId() {
	return document.querySelector('.mm-cart-wrapper').id.replace('shopify-section-', '');
}

/**
 * Add a product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 */
function mmAddProductToCart(productId, { quantity = 1, openCart = false }) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [
                {
                    id: productId,
                    quantity: quantity,
                },
            ],
			// sections: mmCartSectionId(),
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Product successfully added to cart:', data);
        if (openCart) {
            showCart();
        }
		// refreshCartFromData(data);
		updateCartCount()
    })
    .catch(error => {
        console.error('Erreur lors de l’ajout au panier:', error);
    });
}

function mmAddProductCrossSellToCart(productId, { quantity = 1, openCart = false }) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [
                {
                    id: productId,
                    quantity: quantity,
                },
            ],
			sections: mmCartSectionId(),
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Product successfully added to cart:', data);
        if (openCart) {
            showCart();
        }
		refreshCartFromData(data);
    })
    .catch(error => {
        console.error('Erreur lors de l’ajout au panier:', error);
    });
}

function mmRefreshForm() {
	const event = new Event("change");
	const productForm = document.querySelector('variant-selector');
	if(productForm) {
		productForm.dispatchEvent(event);
	}
}

/**
 * Increase the quantity of a specific product in the cart by one.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

/**
 * Decrease the quantity of a specific product in the cart by one.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    // If quantity reaches 0, remove immediately without debounce
    if (newQuantity === 0) {
        mmPushNewQuantity(productVariantId);
    } else {
        mmDebouncedPushNewQuantity(productVariantId);
    }
}

/**
 * Remove a specific product from the cart.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    // Don't use debounce for deletion - apply immediately
    mmPushNewQuantity(productVariantId);
}

function mmDestroyXSellItemFromCart(productVariantId) {
	console.log("productVariantId",productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/**
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    mmAPIRequest('POST', 'cart/change.js', {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/**
 * Debounced function to push new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);

/**
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

/**
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount() {
	fetch('/cart.js')
	.then(response => response.json())
	.then(data => {
		const value = data.item_count;
		if (value > 0) {
			document.querySelector('.mm-cart-count-bubble').classList.remove('mm-none');
			document.querySelector('.mm-cart-count-bubble').innerText = value;
		} else {
			document.querySelector('.mm-cart-count-bubble').classList.add('mm-none');
		}
	})
	.catch(error => {
		console.error('Erreur lors de la récupération du panier:', error);
	});
}

window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
});

// Upsell cart page
function mmChangeProductToNextSize(clickedElem, variant_id_to_remove, variant_id_to_add, add_property) {
	clickedElem.classList.add('mm-loading');
	const productIdToAdd = parseInt(variant_id_to_add, 10);
	const item_card = clickedElem.closest('.mm-dc-product-container');
	const quantity = item_card.querySelector('.mm-dc-product-qqty-number').dataset.itemQuantity;

	// Supprimer l'ancien produit (variant_id_to_remove)
	mmAPIRequest('POST', 'cart/change.js', {
		id: variant_id_to_remove,
		quantity: 0,
		sections: mmCartSectionId()
	})
	.then(() => {
		// Une fois le produit supprimé, on ajoute le nouveau produit
		let itemToAdd = {
			quantity: quantity,
			id: productIdToAdd
		};

		// Si add_property est true, ajouter les properties
		if (add_property) {
			itemToAdd.properties = {
				'_downsell': variant_id_to_remove
			};
		}
		return mmAPIRequest('POST', 'cart/add.js', {
			items: [itemToAdd],
			sections: mmCartSectionId()
		});
	})
	.then(refreshCartFromData) // Rafraîchir le panier
	.catch((error) => {
		// Gestion des erreurs
		clickedElem.classList.remove('mm-loading');
		alert("Impossible d'ajouter ce produit au panier - il n'est peut-être plus en stock !");
		console.log(error);
	});
}

function mmChangeCrosSellQuantity(clickeElem, delta) {
	const card = clickeElem.closest('.mm-dc-cs-product-container');
	const valueInput = card.querySelector('.mm-dc-product-qqty-number');
	const price = card.querySelector('[data-product-price]');
	const compare_at_price = card.querySelector('[data-product-compare-at-price]');

	const newValue = parseInt(valueInput.dataset.itemQuantity) + delta;
	if(newValue < 1) {
		valueInput.dataset.itemQuantity = 1;
		valueInput.innerText = 1;
	} else {
		valueInput.dataset.itemQuantity = newValue;
		valueInput.innerText = newValue;
	}

	// Change CTA price
	const unit_price = price.dataset.value;
	const new_price = unit_price * newValue / 100;
	price.innerText = `${new_price}€`;

	// Change CTA compare at price
	const unit_compare_at_price = compare_at_price.dataset.value;
	const new_compare_at_price = unit_compare_at_price * newValue / 100;
	compare_at_price.innerText = `${new_compare_at_price}€`;
}

// Toaster when add a product to cart
function showCartToast() {
	const toast = document.querySelector('.mm-cart-toast');
	const filter = document.querySelector('.mm-filter-toaster');

	if (!toast) {
		console.error('Toaster HTML manquant ou mal configuré.');
		return;
	}

	toast.classList.add('mm-show');
	filter.classList.add('active');


	setTimeout(() => {
		toast.classList.remove('mm-show');
	}, 5000);
}

function hideCartToast() {
	const toast = document.querySelector('.mm-cart-toast');
	const filter = document.querySelector('.mm-filter-toaster');


	toast.classList.remove('mm-show');
	filter.classList.remove('active');
}

// Eco part total
function ecoPartSum() {
	const ecoParts = document.querySelectorAll('[data-item-eco-part]');
	const ecoPartsContainer = document.querySelector('.mm-cart-footer-eco-participation');
	const totalEcoPartDiv = document.querySelector('.mm-cart-footer-eco-participation-total');

	let totalEcoPart = 0;

	ecoParts.forEach((ecoPart) => {
		const value = parseFloat(ecoPart.dataset.itemEcoPart);
		if (!isNaN(value)) {
			totalEcoPart += value;
		}
	});

	totalEcoPart /= 100;

	if (totalEcoPartDiv) {
		totalEcoPartDiv.textContent = `${totalEcoPart.toFixed(2)} €`;
	}

	if (ecoPartsContainer) {
		ecoPartsContainer.style.display = totalEcoPart === 0 ? 'none' : 'block';
	}
}

function showCrossSellMobile(){
	const crossSellMobileContainer = document.querySelector('.mm-cart-cross-sell');

	crossSellMobileContainer.classList.add('mm-show');
	document.querySelector("html").classList.add("stop-scrolling");
}

function hideCrossSellMobile(){
	const crossSellMobileContainer = document.querySelector('.mm-cart-cross-sell');

	crossSellMobileContainer.classList.remove('mm-show');
	document.querySelector("html").classList.remove("stop-scrolling");
}

function changeCrossSellCtaText(){
	const ctaText = document.querySelector('.mm-cart-cross-sell-mobile-bottom .original-content');

	ctaText.textContent ='Finaliser ma commande';
}

// Adjust mobile cart products container
function adjustCartHeight() {
	const cartProducts = document.querySelector('.mm-cart-products');
	const cartReassuranceRight = document.querySelector('.mm-cart-reassurance-right');
	const cartFooterReassurance = document.querySelector('.mm-cart-footer-reassurance');
	const cartFooter = document.querySelector('.mm-cart-footer');

	if (cartProducts) {
		// Calcule la hauteur totale des trois éléments
		const totalHeight = [
			cartReassuranceRight,
			cartFooterReassurance,
			cartFooter
		].reduce((sum, element) => {
			return sum + (element ? element.offsetHeight : 0);
		}, 0);

		if (window.innerWidth <= 768) { // Seuil pour le mobile (peut être ajusté)
			cartProducts.style.height = `calc(100svh - ${totalHeight}px + var(--header-height-mobile) + var(--announcement-bar-height-mobile))`;
		} else {
			cartProducts.style.height = ''; // Réinitialiser sur desktop
		}
	}
}

// Ajuste la hauteur au chargement et lors des redimensionnements de la fenêtre
adjustCartHeight();
window.addEventListener('resize', adjustCartHeight);


// Envoie les notes d'instruction de livraison dans le champ note de la commande
function sendDeliveryInstructions() {
    const checkoutButtons = document.querySelectorAll(".mm-btn-checkout");
    const notesFields = document.querySelectorAll(".mm-cart-notes");
    if (checkoutButtons.length > 0 && notesFields.length > 0) {
        checkoutButtons.forEach(button => {
            button.addEventListener("click", function (event) {
                event.preventDefault();

                let combinedNotes = "";

                notesFields.forEach(field => {
                    if (field.value.trim() !== "") {
                        combinedNotes += (combinedNotes ? "\n" : "") + field.value.trim();
                    }
                });
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ note: combinedNotes })
                })
                .then(response => response.json())
                .then(() => {
                    window.location.href = "/checkout";
                })
                .catch(error => console.error("Erreur lors de la mise à jour du panier :", error));
            });
        });
    }
}
